import { render } from "./TermsConditionPage.vue?vue&type=template&id=cc739f58&scoped=true"
import script from "./TermsConditionPage.vue?vue&type=script&lang=js"
export * from "./TermsConditionPage.vue?vue&type=script&lang=js"

import "./TermsConditionPage.vue?vue&type=style&index=0&id=cc739f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc739f58"]])

export default __exports__